/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GenerateGlobalLeaderboardResponse } from '../models/generate-global-leaderboard-response';
import { leaderboardServiceGenerateGlobalLeaderboard } from '../fn/leaderboard-service/leaderboard-service-generate-global-leaderboard';
import { LeaderboardServiceGenerateGlobalLeaderboard$Params } from '../fn/leaderboard-service/leaderboard-service-generate-global-leaderboard';

@Injectable({ providedIn: 'root' })
export class LeaderboardServiceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `leaderboardServiceGenerateGlobalLeaderboard()` */
  static readonly LeaderboardServiceGenerateGlobalLeaderboardPath = '/api/v3/gateway/leaderboard/global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leaderboardServiceGenerateGlobalLeaderboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  leaderboardServiceGenerateGlobalLeaderboard$Response(params?: LeaderboardServiceGenerateGlobalLeaderboard$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateGlobalLeaderboardResponse>> {
    return leaderboardServiceGenerateGlobalLeaderboard(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leaderboardServiceGenerateGlobalLeaderboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  leaderboardServiceGenerateGlobalLeaderboard(params?: LeaderboardServiceGenerateGlobalLeaderboard$Params, context?: HttpContext): Observable<GenerateGlobalLeaderboardResponse> {
    return this.leaderboardServiceGenerateGlobalLeaderboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenerateGlobalLeaderboardResponse>): GenerateGlobalLeaderboardResponse => r.body)
    );
  }

}
